import { render, staticRenderFns } from "./LAlert.vue?vue&type=template&id=6dc4700a&scoped=true"
import script from "./LAlert.vue?vue&type=script&lang=js"
export * from "./LAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc4700a",
  null
  
)

export default component.exports